import React from 'react'
import { Link } from 'react-router-dom'
import classes from './Header.module.css'
import arrow from '../img/arrow.png'
import settings from '../img/settings.png'

const Header = props => {
    return (
        <>
            <div className={classes.header}>
                <Link to='/'>
                    <img className={classes.immages} src={arrow} alt="home" />
                </Link>
                <h2 className={classes.title}>{props.title}</h2>

                <img className={classes.immages} src={settings} alt="settings" onClick={props.onClose}/>

            </div>
        </>
    )
}

export default Header